import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/actionCustomNotification/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemNotification({ id, params }) {
  return request(`/actionCustomNotification/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewNotification(params) {
  return request.post(`/actionCustomNotification`, {
    data: params,
  });
}

export async function queryAddEditNotification(params) {
  return request.put('/actionCustomNotification', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionCustomNotification/${id}`, {});
}
